export const SECTION_DATA_TO_RETRIEVE = `
  id
  name
  code
`;
